/**
 * Auto-generated friendly device names (“Chrome on Mac”, “Safari on iPhone”).
 */

import { getNativePlatform, isNativeApp } from '../../../utils/platform'

function browserName(ua: string): string {
  if (/Edg\//i.test(ua)) return 'Edge'
  if (/OPR\//i.test(ua) || /Opera/i.test(ua)) return 'Opera'
  if (/Firefox\//i.test(ua)) return 'Firefox'
  if (/Chrome\//i.test(ua) && !/Edg\//i.test(ua)) return 'Chrome'
  if (/Safari\//i.test(ua) && !/Chrome\//i.test(ua)) return 'Safari'
  return 'Browser'
}

function osName(ua: string): string {
  if (/iPhone/i.test(ua)) return 'iPhone'
  if (/iPad/i.test(ua)) return 'iPad'
  if (/Android/i.test(ua)) return 'Android'
  if (/Mac OS X/i.test(ua) || /Macintosh/i.test(ua)) return 'Mac'
  if (/Windows/i.test(ua)) return 'Windows'
  if (/Linux/i.test(ua)) return 'Linux'
  return 'device'
}

/** Best-effort auto display name for this install / browser. */
export function buildAutoDeviceDisplayName(): string {
  if (isNativeApp()) {
    const platform = getNativePlatform()
    if (platform === 'ios') return 'iPhone'
    if (platform === 'android') return 'Android phone'
    return 'Mobile app'
  }
  if (typeof navigator === 'undefined') return 'Web browser'
  const ua = navigator.userAgent || ''
  return `${browserName(ua)} on ${osName(ua)}`
}

export function resolveDevicePlatform(): 'ios' | 'android' | 'web' {
  if (isNativeApp()) {
    const p = getNativePlatform()
    return p === 'ios' || p === 'android' ? p : 'web'
  }
  return 'web'
}

/** Coarse location hint from timezone (never precise GPS). */
export function coarseLocationHint(): string | null {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (!tz) return null
    // "Australia/Sydney" → "Sydney"
    const parts = tz.split('/')
    const city = parts[parts.length - 1]?.replace(/_/g, ' ')
    return city || tz
  } catch {
    return null
  }
}

export function formatLastActive(iso: string, nowMs: number = Date.now()): string {
  const t = Date.parse(iso)
  if (!Number.isFinite(t)) return 'Unknown'
  const delta = Math.max(0, nowMs - t)
  const mins = Math.floor(delta / 60_000)
  if (mins < 1) return 'Just now'
  if (mins < 60) return `${mins}m ago`
  const hours = Math.floor(mins / 60)
  if (hours < 48) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  return `${days}d ago`
}

/** "9 Aug 2026" — the day a device was added. */
export function formatAddedDate(iso: string): string {
  const t = Date.parse(iso)
  if (!Number.isFinite(t)) return 'Unknown'
  return new Date(t).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' })
}
